import { createGlobalStyle } from 'styled-components';
import { colors } from 'ui/constants';
import { zoom } from 'utils/zoom';
import { isFramed } from 'utils/iframe';
import BlueArrow from './images/BlueArrow.svg';
import { ipexGalleryEnabled } from 'app';

// eslint-disable-next-line no-unused-expressions
const GlobalStyle = createGlobalStyle`
  html,
  body {
    width: 100%;

    /* Only set if we are not in an iframe */
    ${window.top !== window.self ? '' : 'height: 100%;'}
  }

  body {
    color: ${colors.textBlack};
    ${zoom ? `zoom: ${zoom}%;` : ''}
  }

  #app {
    background-color: ${colors.white};
    min-height: 100%;
    min-width: 100%;
  }

  ${isFramed && `
    #app::after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      pointer-events: none;
      z-index: 1000;
      
      @media print {
        border: none;
      }
    }
  `}

  input:focus {
    outline: none;
  }

  .swiper-container {
    overflow: visible;
  }

  .swiper-button-next {
    background-image: url(${BlueArrow});
    transform: scale(-1);
  }

  .swiper-button-prev {
    background-image: url(${BlueArrow});
  }

  #app .swipe-select,
  #app .selection-gallery-swiper {
    .swiper-button-next,
    .swiper-button-prev {
      background-size: 68px;
    }
  }

  ::-ms-clear {
    display: none;
  }

  ::placeholder {
    color: ${colors.lightergray} !important;
  }

  svg {
    vertical-align: top;
  }
  
`;

export default GlobalStyle;